module.exports = "/_next/static/images/47ef8a0d1896040ab03d39eb4d4f0f18-hero-md-1x.jpg";